export function toProperCase(string) {
    // eslint-disable-next-line prefer-arrow-callback
    return string.replace(/\w\S*/g, function convertToProperCase(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
